// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {SvgIconEl} from 'common/components/svg-icon';

import type {Checkbox} from './index';
import styles from './index.module.styl';

export function template(this: Checkbox) {
  return (
    <div sel={selx(styles.mpCheckboxWrapper)} class={this.helpers.getClasses()}>
      <div sel={selx(styles.mpCheckboxIcon, `item-icon`)} style={this.helpers.getIconStyles()}>
        <div sel={selx(styles.mpCheckboxAnimationLayer)} />
        <SvgIconEl attrs={this.helpers.getIconAttributes()} />
      </div>
      {this.attr(`icon`) ? (
        <div sel={selx(styles.mpCheckboxAdditionalIcon)}>
          <SvgIconEl attrs={{icon: this.attr(`icon`)}} />
        </div>
      ) : null}
      <div sel={selx(styles.mpCheckboxLabel)}>
        <slot />
      </div>
    </div>
  );
}
